module.exports = __webpack_public_path__ + "img/biaoqian_cangku.6e2af17e.png";